import React from 'react';
import Image from 'Assets/images/discount-banner-modal.png';
import AppStore from 'Assets/images/app-store.png';
import playStore from 'Assets/images/play-store.png';
import { Link } from 'react-router-dom';

const DiscountBannerModal = ({ setClose }) => {
  return (
    <div className="discount-banner-modal">
      <div className="discount-banner-modal-container">
        <Link
          to="https://apps.apple.com/in/app/unipath-blood-test/id6711355606"
          target="_blank"
        >
          <img
            id="appStoreModal"
            src={AppStore}
          />
        </Link>
        <Link
          to="https://play.google.com/store/apps/details?id=com.unipath"
          target="_blank"
        >
          <img
            id="playStoreMdal"
            src={playStore}
          />
        </Link>
        <p id="termsAndConditionsModal">
          <Link to="/terms-of-use">*Terms and Conditions Apply</Link>
        </p>
        <button
          type="button"
          className="btn-close"
          id="removeButtonModal"
          aria-label="Close"
          onClick={() => setClose()}
        ></button>
      </div>
    </div>
  );
};

export default DiscountBannerModal;
